import TncPage from "@/components/tnc/TncPage";
import {
  eumeTncFooterNote,
  eumeTncHero,
  eumeTncPreface,
  eumeTncSections,
} from "./tncContent";

export default function EumeAccidentalTnc() {
  return (
    <TncPage
      hero={eumeTncHero}
      preface={eumeTncPreface}
      sections={eumeTncSections}
      footerNote={eumeTncFooterNote}
      path="/eume/accidental/tnc"
    />
  );
}
